import React, { useRef, useState } from "react";
import { GetAdvancedTemplate, GetBasicTemplates } from "./templates";
import Slider from "react-slick";
import { useLocation } from "react-router-dom";
import useRequest from "./../../../api/useRequest";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { CarouselsRequestFactory } from "../../../api/requestFactory";
import { NotificationContext } from "../../../context/notification-context";
import { useNavigate } from "react-router-dom";
import NumberOfSlideSetter from "./number-of-slide-setter";
import { getStoredWorkspace } from "../../../api/workspace";
import CarouselsHeader from "./carousel-header";
import * as Mixpanel from "../../../services/mixpanel";

function GenerateWithAISelection() {
  const { state } = useLocation();
  const { postContent } = state || {};
  const { requestMaker } = useRequest();
  const { showNotification } = React.useContext(NotificationContext);
  const navigate = useNavigate();
  const [showNumberOfSlidesSetter, setShowNumberOfSlidesSetter] =
    useState(false);
  const [chosenTemplate, setChosenTemplate] = useState(null);

  const imageClass1 =
    "relative visible object-cover w-full h-full transition-all duration-150 bg-teal-100";
  const settings = {
    dots: false,
    infinite: true,
    speed: 2000,
    autoplaySpeed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const advancedTemplate = GetAdvancedTemplate();
  const basicTemplates = GetBasicTemplates();

  const basicSliderRefs = useRef([]);
  const advancedSliderRef = useRef(null);

  React.useEffect(() => {
    basicSliderRefs.current = basicSliderRefs.current.slice(
      0,
      basicTemplates.length
    );
  }, [basicTemplates]);

  const createCarousel = (template, numberOfSlides = 5) => {
    const currentWorkspaceId = getStoredWorkspace();

    requestMaker(
      CarouselsRequestFactory.createSaveCarouselRequest(
        template.slides,
        template.common_settings,
        postContent,
        template.id
      )
    )
      .then((response) => {
        // Always navigate to text-to-carousel for AI generation flow
        navigate(`/ai/carousels/text-to-carousel/?workspace_id=${currentWorkspaceId}`, {
          state: { carousel: response.carousel, numberOfSlides: numberOfSlides },
        });
      })
      .catch((error) => {
        console.error(error);
        showNotification(
          {
            title: "Error",
            content: "Something went wrong. Please try again later.",
          },
          "error"
        );
      });
  };

  const handleTemplateClick = (template) => {
    setChosenTemplate(template);
    setShowNumberOfSlidesSetter(true);
    Mixpanel.track("Template Selected for Carousel", { templateId: template.id })
  };

  return (
    <div className="fixed inset-0 z-20 flex flex-col bg-gray-50">
    <CarouselsHeader 
      title="Text to Carousel"
      subTitle="with AI-powered carousel generation"
      onBack={() => navigate("/ai/carousels")}
    />
      <div className="flex-1 overflow-y-auto min-h-0">
        <div className="space-y-2 sm:space-y-8 px-4 md:px-6 py-4 pb-8">
        <div className="flex flex-col justify-center gap-4 sm:gap-6 sm:flex-row sm:items-center">
          <div>
            <p className="text-lg font-semibold text-center text-gray-900">
              Choose Your Template
            </p>

            <p className="mt-1 text-sm font-normal text-gray-500 text-center">
              The carousel will be generated based on your text and selected template.
            </p>
          </div>
        </div>
        <div>
         

          <div className="mt-10">
          
            <div className="grid grid-cols-1 gap-6 mt-4 sm:grid-cols-3 lg:grid-cols-3 xl:grid-cols-6">
              {basicTemplates.map((template, index) => {
                return (
                  <div key={index} className="relative group">
                    {parseInt(template.id) >= 20 && (
                      <div className="absolute z-10 top-2 right-2 bg-blue-500 text-sm px-2 py-1 font-semibold text-white rounded-full">
                        New
                      </div>
                    )}

                    <div
                      onClick={() => handleTemplateClick(template)}
                      onMouseEnter={() =>
                        basicSliderRefs.current[index]?.slickPlay()
                      }
                      onMouseLeave={() =>
                        basicSliderRefs.current[index]?.slickPause()
                      }
                      className="overflow-hidden cursor-pointer relative aspect-[4/5] rounded-xl ring-1 ring-gray-200 shadow-xs"
                    >
                      <Slider
                        {...settings}
                        ref={(el) => (basicSliderRefs.current[index] = el)}
                      >
                        {template.preview_images.map((image, index) => {
                          return (
                            <img
                              key={index}
                              className={imageClass1}
                              src={image}
                              alt=""
                            />
                          );
                        })}
                      </Slider>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="mt-4">
            <h2 className="text-xl font-semibold text-gray-900">Advanced</h2>
            <p className="mt-1 text-sm font-normal text-gray-900">
              Highly customizable drag-and-drop template with font family, size,
              colour, and alignment options.
            </p>
            <div className="grid grid-cols-1 gap-6 mt-4 sm:grid-cols-3 lg:grid-cols-3 xl:grid-cols-6">
              <div className="relative group">
                <div className="relative group">
                  <div
                    onClick={() => handleTemplateClick(advancedTemplate)}
                    onMouseEnter={() => advancedSliderRef.current?.slickPlay()}
                    onMouseLeave={() => advancedSliderRef.current?.slickPause()}
                    className="overflow-hidden cursor-pointer relative aspect-[4/5] rounded-xl ring-1 ring-gray-200 shadow-xs"
                  >
                    <Slider {...settings} ref={advancedSliderRef}>
                      {advancedTemplate.preview_images.map((image, index) => {
                        return (
                          <img
                            key={index}
                            className={imageClass1}
                            src={image}
                            alt=""
                          />
                        );
                      })}
                    </Slider>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
      {showNumberOfSlidesSetter && (
        <NumberOfSlideSetter
          generateCarousel={(val) => {
            setShowNumberOfSlidesSetter(false);
            if (!chosenTemplate) return;
            createCarousel(chosenTemplate, val);
          }}
          onClose={() => setShowNumberOfSlidesSetter(false)}
        />
      )}
    </div>
  );
}

export default GenerateWithAISelection;
